import { useScale } from "hooks/size";
import { HomeButton as HomeButtonComponent } from "./HomeButton";
import styled from "styled-components";
import { useStore } from "utils/store";
import * as Sentry from "@sentry/react";

export const HomeButton = () => {
  const returnUrl = useStore((state) => state.returnUrl);
  const { scale } = useScale();

  if (!returnUrl) {
    return (
      <Placeholder></Placeholder>
    );
  }

  const onClick = () => {
    try {
      const url = new URL(returnUrl);
      window.location.href = url.href;
    } catch (error) {
      console.error("Invalid returnUrl:", returnUrl);
      Sentry.captureException(new Error(`Invalid returnUrl: ${returnUrl}`), {
        extra: { returnUrl, error },
      });
    }
  };

  return (
    <HomeButtonComponent 
      onClick={onClick}
      scale={scale}
    />
  );
};

const Placeholder = styled.div`
  height: 0.8vh;
  pointer-events: none;
`;
